export default class UserEventsOutgoing {
  public static readonly SET_LIST = "USER_EVENTS_OUTGOING_SET_LIST";
  public static readonly SET_COUNTER = "USER_EVENTS_OUTGOING_SET_COUNTER";
  public static readonly SET_STATUS = "USER_EVENTS_OUTGOING_SET_STATUS";
  public static readonly SET_ERROR = "USER_EVENTS_OUTGOING_SET_ERROR";
  public static readonly CLEAR = "USER_EVENTS_OUTGOING_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: UserEventsOutgoing.SET_LIST,
    };
  }

  public static setCounter(data: any) {
    return {
      data,
      type: UserEventsOutgoing.SET_COUNTER,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: UserEventsOutgoing.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: UserEventsOutgoing.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: UserEventsOutgoing.CLEAR,
    };
  }
}
